import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { Sample } from './sample-models';
import { Observable } from 'rxjs';
import { CORE_CONFIG } from '../environment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SampleService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
              @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/sample`;
  }

  getSampleList(params: { [param: string]: any }): Observable<AutoTablePageableResponse<Sample>> {
    return this.httpClient.get<AutoTablePageableResponse<Sample>>(`${this._baseURL}s`, {
      params
    });
  }

  newSample(code: string, formData: FormData): Observable<any> {
    return this.httpClient.post(`${this._baseURL}/${code}`, formData);
  }

  newSampleBulk(manufacturerName: string, formData: FormData): Observable<any> {
    return this.httpClient.post(`${this._baseURL}s/${manufacturerName}`, formData);
  }

  removeSample(code: string | string[]): Observable<any> {
    if (_.isArray(code)) {
      return this.httpClient.delete(`${this._baseURL}`, {
        params: {
          code
        }
      });
    } else {
      return this.httpClient.delete(`${this._baseURL}/${code}`);
    }
  }

  updateSampleViews(code: number): Observable<any> {
    return this.httpClient.put(`${this._baseURL}views/${code}`, {});
  }
}
